import validate from "/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_d9475560e83a2a1ab749ec1fbc0c7f46/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_d9475560e83a2a1ab749ec1fbc0c7f46/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/intranet/app/middleware/auth.ts")
}